import React from 'react'
import { Box, IcoMoon } from '@usap/uicomponents'
import { Heading1, Heading3 } from '../common/heading'

import {
  Container,
  IconBox,
} from './IconHeaderCard.css'

export default function IconHeaderCard({
  heading,
  subHeading = '',
  icon,
  iconSize,
  boxSize,
  dashboard,
  order,
}) {
 
  return (
    <Container  order={order} dashboard={dashboard}>
      <IconBox  boxSize={boxSize}>
        <IcoMoon icon={icon} color="brand" size={iconSize} />
      </IconBox>
      <Box align="start" justify="center"> 
      {dashboard ? (
          <Heading3 title={heading} />
        ) : (
          <Heading1 title={heading} />
        )}
         {subHeading}
      </Box>
    </Container>
  )
}